/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_65accb41{display:block}.root_65accb41>img{display:block}.root_65accb41.inset24_65accb41{padding:2px}\n"}]);
export const root = "root_65accb41";
export const inset24 = "inset24_65accb41";